export const PRODUCT_ACTION_BASE_QUERY_KEY = 'productActions';
